module.exports = __webpack_public_path__ + "static/media/void-fish.dde35d2d.png";